import React from 'react';
import { getProbationDisplay } from '../../utils/accountProbation';

function FieldShell({ label, children, wide = false, variant = 'profile' }) {
  const shellClasses =
    variant === 'details'
      ? 'rounded-lg border border-gray-100 bg-[#faf8f5] px-3 py-2.5'
      : 'rounded-lg border border-gray-100 bg-[#faf8f5] px-3 py-2.5 sm:border-0 sm:bg-transparent sm:px-0 sm:py-0';

  return (
    <div className={`${shellClasses} ${wide ? 'sm:col-span-2' : ''}`}>
      <p className="text-xs text-gray-500">{label}</p>
      {children}
    </div>
  );
}

function ProbationInfoFields({ onProbation, completionDate, variant = 'profile' }) {
  const display = getProbationDisplay(onProbation, completionDate);

  return (
    <>
      <FieldShell label="On Probation" variant={variant}>
        <p
          className={`mt-0.5 text-sm font-semibold ${
            display.isOnProbation
              ? 'text-amber-700'
              : display.isOffProbation
                ? 'text-emerald-700'
                : 'text-gray-900'
          }`}
        >
          {display.onProbationLabel}
        </p>
      </FieldShell>
      <FieldShell label="Probation Completion Date" variant={variant}>
        <p
          className={`mt-0.5 text-sm font-medium ${
            display.isOnProbation ? 'text-amber-600' : 'text-gray-900'
          }`}
        >
          {display.completionDateLabel}
        </p>
      </FieldShell>
    </>
  );
}

export default ProbationInfoFields;
